import { createApp } from '@backstage/frontend-defaults';
import authPlugin from '@backstage/plugin-auth';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { compatWrapper, convertLegacyPlugin } from '@backstage/core-compat-api';
import { navModule } from './modules/nav';
import { githubAuthApiRef, configApiRef, useApi } from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { endOfLifePlugin } from '@dweber019/backstage-plugin-endoflife';
// Import raw component directly — the default export wraps it in createRoutableExtension which breaks in new frontend system
import { EntityEndOfLifeCard } from '@dweber019/backstage-plugin-endoflife/dist/components/EntityEndOfLifeCard/index.esm.js';
import githubActionsPlugin from '@backstage-community/plugin-github-actions/alpha';

const githubProvider = {
  id: 'github-auth-provider',
  title: 'GitHub',
  message: 'Sign in using GitHub',
  apiRef: githubAuthApiRef,
};

function SignInPageWithProviders(props: any) {
  const config = useApi(configApiRef);
  const isDev = config.getOptionalString('auth.environment') !== 'production';
  return (
    <SignInPage
      {...props}
      providers={isDev ? ['guest', githubProvider] : [githubProvider]}
    />
  );
}

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => <SignInPageWithProviders {...props} />,
  },
});

const convertedEndOfLifePlugin = convertLegacyPlugin(endOfLifePlugin, {
  extensions: [],
});

const endOfLifeCard = EntityCardBlueprint.make({
  name: 'endoflife',
  params: {
    loader: async () => compatWrapper(<EntityEndOfLifeCard />),
  },
});

const catalogExtensionsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [endOfLifeCard],
});

const rootModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});

export default createApp({
  features: [authPlugin, catalogPlugin, notificationsPlugin, apiDocsPlugin, convertedEndOfLifePlugin, githubActionsPlugin, catalogExtensionsModule, navModule, rootModule],
});
